import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { ReturnsSettingsPage } from '@/features/returns';
import { storeQueryOptions } from '@/features/stores';

export const Route = createFileRoute('/_authed/_active/s/$storeId/settings/returns')({
  staticData: { crumb: 'common:nav.returnsSettings', tours: ['settings.returns'] },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'settings.read');
  },
  loader: ({ context, params }) =>
    context.queryClient
      .query({ ...storeQueryOptions(params.storeId), staleTime: 'static' })
      .catch(() => undefined),
  component: ReturnsSettingsPage,
});
